import {StyleSheet}  from 'react-native'

import cores from './cores'
import dimens from './dimens'


const estilos = StyleSheet.create({


	/* ____________________ geral ________________________ */


	checkbox: {
        alignSelf: 'center',
    },

	

	sombra: {
        shadowColor: '#171717',
        shadowOffset: {width: -3, height: 3},
        shadowOpacity: 0.2,
        shadowRadius: 3,
        elevation: 10,
    },

	separador:{
       borderBottomColor: 'black',
       borderBottomWidth: 1
    },
  
    separador_cinza_claro:{
        borderBottomColor: cores.cinza_claro,
        borderBottomWidth: 1
    },
	
	separador_claro:{
        borderBottomColor: cores.fonte_clara,
        borderBottomWidth: 1
    },
	
	grade:{
        flexDirection:'row'
    },

    coluna:{

        flex: 1
    },

    
    coluna_dupla:{

        flex: 2
    },
    
    coluna_tripla:{

        flex: 3
    },



	/* ____________________ rotulos ________________________ */



    rotulo_padrao:{
        marginTop:5,
        fontSize:dimens.fonte_rotulo,
        color:cores.fonte_escura,
    },

    rotulo_titulo:{
        marginTop:5,
        fontSize:dimens.fonte_maior,
        fontWeight: "bold",
        color:cores.fonte_escura
    },

    rotulo_menor:{
        color:cores.fonte_escura,
        fontSize:dimens.fonte_rotulo_menor
    },
   



	/* ____________________ campos de texto ________________________ */



    campo_padrao:{
        borderBottomWidth:2,
        marginTop:1,
        fontSize:dimens.fonte_campo,
        borderBottomColor: cores.cinza_medio,
        backgroundColor: cores.cinza_claro,
        borderRadius:4,
        padding: 7
    },

    area_texto_padrao:{
        borderBottomWidth:2,
        marginTop:5,
        fontSize:dimens.fonte_campo,
        borderBottomColor: cores.cinza_medio,
        backgroundColor: cores.cinza_claro,
        borderRadius:4,
        padding: 7
    },



    /* ____________________ botoes ________________________ */



    /* ____________________ combo ________________________ */

    
	combo_padrao:{
        fontSize:dimens.fonte_campo,
        backgroundColor: cores.cinza_claro,
        borderRadius:4
    },

    
})


export {estilos};